var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLoader)?_c('v-overlay',[_c('v-progress-circular',{staticClass:"mb-0 progress-circular",attrs:{"id":"iiotApiLoadingCircular","indeterminate":"","size":"70","width":"7"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }